"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _insurance = require("@nerdwallet/marketplace/drivers/insurance");
var _common = require("@nerdwallet/marketplace/selectors/common");
var _constants = require("@nerdwallet/marketplace/constants");
var _default = function _default(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  var subProductType = (0, _common.getSubProductType)(marketplaceEntity);
  var drivers = [];
  switch (subProductType) {
    case _constants.INSURANCE_SUB_PRODUCT_TYPES.HOME:
    case _constants.INSURANCE_SUB_PRODUCT_TYPES.HOMEOWNERS_PROPERTY:
      drivers = [(0, _insurance.getDriverNAICComplaints)(marketplaceEntity), (0, _insurance.getDriverCoverageOptions)(marketplaceEntity), (0, _insurance.getDriverDiscounts)(marketplaceEntity)];
      break;
    case _constants.INSURANCE_SUB_PRODUCT_TYPES.LIFE:
    case _constants.INSURANCE_SUB_PRODUCT_TYPES.LIFE_SUB:
      drivers = [(0, _insurance.getDriverFinancialStrengthRating)(marketplaceEntity), (0, _insurance.getDriverNAICComplaints)(marketplaceEntity), (0, _insurance.getDriverPoliciesOffered)(marketplaceEntity), (0, _insurance.getDriverCanBuyOnline)(marketplaceEntity)];
      break;
    case _constants.INSURANCE_SUB_PRODUCT_TYPES.AUTO:
    case _constants.INSURANCE_SUB_PRODUCT_TYPES.CAR:
    default:
      drivers = [(0, _insurance.getDriverNAICComplaints)(marketplaceEntity), (0, _insurance.getDriverEaseOfUse)(marketplaceEntity), (0, _insurance.getDriverDiscounts)(marketplaceEntity)];
      break;
  }
  return {
    drivers: drivers
  };
};
exports.default = _default;